<template>
  <section>
    <div>
      <form class="lm-forms">
        <div class="columns">
          <div class="column is-6 local-lm-filters">
            <b-field
              class="lm-label"
              :label="$t('NewPartner.labelName')"
            >
              <b-input
                class="local-lm-filters--input"
                v-model.trim="$v.name.$model"
              />
            </b-field>
            <b-field
              class="lm-label"
              :label="$t('NewPartner.labelSurname')"
            >
              <b-input
                class="local-lm-filters--input"
                v-model.trim="$v.surname.$model"
              />
            </b-field>
            <b-field
              class="lm-label"
              :label="$t('NewPartner.labelEmail')"
              :type="validateTypeEmail"
              :message="errorMessageEmail"
            >
              <b-input
                type="email"
                class="local-lm-filters--input"
                v-model.trim="$v.email.$model"
              />
            </b-field>
            <div class="buttons lr-rd-space-mTop">
              <b-button
                v-t="'Common.register'"
                type="is-success"
                class="button lr-width-50 lr-btn lr-txt-up"
                :disabled="disabled"
                @click.prevent="submitData"
              />
            </div>
          </div>
          <div class="column is-6 local-lm-filters">
            <b-field
              class="local-lm-taginput-align"
              :label="$t('NewPartner.labelPerfil')"
            >
              <b-taginput
                v-model.trim="selectedProfile"
                class="local-lm-filters"
                :data="allowProfiles"
                field="translation"
                type="is-success"
                autocomplete
                :allow-new="allowNew"
                :open-on-focus="openOnFocus"
                icon="label"
                :placeholder="$t('NewPartner.profilePlaceholder')"
                @input="checkSelected"
              >
              </b-taginput>
            </b-field>
            <b-field
              v-if="visibleDrop"
              class="lm-label"
              :label="$t('NewPartner.labelPartner')"
            >
              <b-dropdown
                aria-role="list"
                class="local-lm-filters"
                v-model="selectedPartner"
                :disabled="disabledPartner"
                @active-change="selectDropPartner"
              >
                <button
                  class="button"
                  type="button"
                  slot="trigger"
                >
                  <div class="local-lm-filters--placeholder">
                    <template>
                      <span
                        v-if="!selectedPartner"
                        v-t="$t('NewPartner.partnerPlaceholder')"
                      />
                      <span
                        v-if="selectedPartner"
                        v-t="getRegistration(selectedPartner).description"
                      />
                    </template>
                    <b-icon
                      icon="chevron-down"
                    />
                  </div>
                </button>
                <b-dropdown-item
                  v-for="(partner, index) in partners"
                  :key="index"
                  :value="partner.id"
                  v-t="partner.operatorName.toUpperCase()"
                />
              </b-dropdown>
            </b-field>
            <b-field
              v-if="visibleDropIfPartner"
              class="lm-label"
              :label="$t('NewPartner.labelStores')"
            >
              <b-dropdown
                aria-role="list"
                class="local-lm-filters"
                v-model="selectedStore"
                @active-change="selectDropStores"
              >
                <button
                  class="button"
                  type="button"
                  slot="trigger"
                >
                  <div
                    class="local-lm-filters--placeholder"
                    :class="{ 'is-danger': !selectedStore }"
                  >
                    <template>
                      <span
                        v-if="!selectedStore"
                        v-t="$t('NewPartner.storePlaceholder')"
                      />
                      <span
                        v-if="selectedStore"
                        v-t="getStoreName(selectedStore).name"
                      />
                    </template>
                    <b-icon
                      icon="chevron-down"
                    />
                  </div>
                </button>
                <b-dropdown-item
                  v-for="(store, index) in stores"
                  :key="index"
                  :value="store.storeCode"
                  v-t="store.name.toUpperCase()"
                />
              </b-dropdown>
            </b-field>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { services } from '@/services'
import { mixin } from '@/mixins'

export default {
  name: 'NewPartner',
  mixins: [
    mixin.notifications
  ],
  computed: {
    ...mapGetters('user', [
      'profiles',
      'partners',
      'stores'
    ]),
    validateTypeEmail () {
      return !this.$v.email.email
        ? 'is-danger'
        : null
    },
    errorMessageEmail () {
      return !this.$v.email.email
        ? this.$t('Errors.validEmail')
        : null
    },
    allProfiles () {
      return this.profiles
    }
  },
  data () {
    return {
      name: '',
      surname: '',
      email: '',
      selectedProfile: null,
      selectedPartner: null,
      selectedStore: null,
      visibleDrop: false,
      visibleDropIfPartner: false,
      openOnFocus: true,
      disabled: false,
      disabledPartner: false,
      filterAll: '',
      allowNew: false,
      allowProfiles: []
    }
  },
  watch: {
    allProfiles (data) {
      const role = this.$store.getters['user/status'].info.authorities
      const rules = services.userService('', role)
      const filter = rules.filtersForProfileDrop()

      if (filter) {
        this.allowProfiles = filter
          .concat(data)
          .map(f => {
            return {
              key: f,
              translation: this.$t(`NewPartner.${f}`).toUpperCase()
            }
          })

        this.filterAll = filter
      }
    }
  },
  mounted () {
    const role = this.$store.getters['user/status'].info.authorities
    const rules = services.userService('', role)
    const showDropPartners = rules.showDropPartner()

    if (showDropPartners) this.visibleDrop = true
  },
  methods: {
    getRegistration (code) {
      const partner = this.partners.find(p => p.id === code)
      const blob = partner
        ? {
          description: partner.operatorName.toUpperCase(),
          id: partner.id
        }
        : ''

      return blob
    },
    getStoreName (storeID) {
      const store = this.stores.find(s => s.storeCode === storeID)
      const blob = store
        ? {
          name: store.name.toUpperCase(),
          storeCode: store.storeCode
        }
        : ''

      return blob
    },
    selectDropPartner () {
      const descPartner = this.getRegistration(this.selectedPartner).description
      this.visibleDropIfPartner = (descPartner === 'CARRO DEDICADO') || false
      this.disabled = (descPartner === 'CARRO DEDICADO') || false
      this.disabledPartner = (descPartner === 'CARRO DEDICADO') || false
      this.selectedStore = (descPartner === 'CARRO DEDICADO') ? this.selectedStore : null
    },
    selectDropStores () {
      this.disabled = (this.selectedStore === null) || false
    },
    checkSelected () {
      const findDedicatedCar = this.selectedProfile.find(profile => profile.key === 'ROLE_DEDICATED_CAR')
      if (findDedicatedCar) {
        const findPartner = this.partners.find(partner => partner.operatorName === 'CARRO DEDICADO')
        this.selectedPartner = findPartner ? findPartner.id : null
        this.selectDropPartner()
        return
      }

      this.selectedPartner = null
      this.selectDropPartner()
    },
    async submitData () {
      this.$v.$touch()

      if (this.$v.name.$invalid ||
          this.$v.surname.$invalid ||
          !this.selectedProfile ||
          (this.visibleDrop && !this.selectedPartner) ||
          (this.visibleDropIfPartner && !this.selectedStore)
      ) {
        return this.wrong(this.$t('Errors.warningAllFieldsWithData'))
      }

      let authorities = []
      const check = this.selectedProfile
        .includes(this.selectedProfile
          .find(p => p.key === this.filterAll[0]))

      if (check) authorities = this.profiles
      if (!authorities.length) authorities = this.selectedProfile.map(p => p.key)

      const body = {
        authorities,
        email: this.email,
        firstName: this.name,
        lastName: this.surname,
        fullName: `${this.name} ${this.surname}`
      }

      if (this.selectedPartner) body.operators = [ this.selectedPartner ]
      body.storeCode = (this.selectedStore) ? this.selectedStore : null

      const changes = await this.$store.dispatch('user/setNewUser', body)
      if (!changes.level) return this.wrong(this.$t(changes.errorText))

      this.name = ''
      this.surname = ''
      this.email = ''
      this.selectedProfile = null
      this.selectedPartner = null
      this.selectedStore = null
      this.visibleDropIfPartner = false
      this.disabledPartner = false
      this.sucess(this.$t('Common.success'))
    }
  },
  validations: {
    name: { required },
    surname: { required },
    email: {
      required,
      email,
      minLength: minLength(8)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/NewPartner.vue